import { AxiosError } from 'axios';
import { POST_GSC_UPLOAD_PRESIGNED_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { PostUploadPresignedUrlRequest, PresignedUrlResponse } from '../../models/PresignedUrl';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUploadPresignedUrl = ({ onSuccess, onError }: Input) => {
  const postUploadPresignedUrl = async (payload: PostUploadPresignedUrlRequest) => {
    const res = await axiosClient.post<PresignedUrlResponse>(
      POST_GSC_UPLOAD_PRESIGNED_URL(payload.uuid),
      {
        fileName: payload.fileName,
      }
    );
    return res.data;
  };

  return useCustomMutation(postUploadPresignedUrl, {
    onSuccess,
    onError,
  });
};
